// extracted by mini-css-extract-plugin
export default {"news":"News_news__xJZFT","decor":"News_decor__Pw3jg","decorI":"News_decorI__VR8vN","dissipate":"News_dissipate__TUKeo","title":"News_title__r5-lG"};